import {merge} from "lodash";
import partnerMessages from "@i18n_messages_pt-BR"

export default merge({}, partnerMessages);